// import COMPANY_API from '@/api/masterData/company.js';
export const searchColumns = (ctx) => {
  return [
    // {
    //   prop: 'settlementCompanyNo',
    //   name: '公司名称',
    //   type: 'ajaxSelect',
    //   apiUrl: COMPANY_API.GET_COMPANY_LIST_API,
    //   apiData: {
    //     adminFlag: ctx.userInfo.adminFlag,
    //     tenantCode: ctx.userInfo.tenantCode,
    //   },
    //   clearable: true,
    //   filterable: true,
    //   valueKey: 'companyCode',
    //   labelKey: 'companyName',
    //   changeMethod: 'changeCompanyHandler',
    //   method: 'post',
    // },
    // {
    //   prop: 'settlementDepartmentNo',
    //   name: '部门',
    //   type: 'ajaxSelect',
    //   apiUrl: COMPANY_API.GET_DEPARTMENT_LIST_API,
    //   apiData: {
    //     belongCompanyCode: ctx.companyCode,
    //     tenantCode: ctx.userInfo.tenantCode,
    //   },
    //   clearable: true,
    //   filterable: true,
    //   disabled: !ctx.companyCode,
    //   valueKey: 'createDepartmentCode',
    //   labelKey: 'departmentName',
    //   method: 'post',
    // },
    {
      name: '客户',
      prop: 'customerNo',
      type: 'searchTableSpec',
      searchType: 'partner',
      isMultiple: true,
      extraData: {
        companyCode: ctx.userInfo.companyCode,
        departmentCode: ctx.userInfo?.departmentCode,
        partnerTypes: 'HZHB01,HZHB03,HZHB11,HZHB10',
      },
      changeMethod: ctx.changeCustomerNoMethod,
    },
    // {
    //   name: '合同编号',
    //   prop: 'contractCode',
    //   type: 'searchTableSpec',
    //   searchType: 'contract',
    //   extraData: {
    //     contractCategory: 'sales',
    //   },
    //   isMultiple: true,
    //   changeMethod: ctx.changeContractMethod,
    // },
    {
      name: '合同编号',
      prop: 'contractCode',
      type: 'searchTableSpec',
      searchType: 'multransportContract',
      extraData: {
        contractStatus: 'ZT03',
        contractType: '0',
        isCS: 'C',
        createDepartmentNo: ctx.userInfo?.departmentCode,
        // createDepartmentNo: 'OAD2',
      },
      isMultiple: true,
      changeMethod: ctx.changeContractMethod,
    },
    {
      name: '订单编号',
      prop: 'orderCode',
      type: 'input',
    },
    {
      name: '指令单编号',
      prop: 'instructCode',
      type: 'input',
    },
    {
      prop: 'productType',
      name: '产品类型',
      type: 'select',
      options: ctx.productList,
      changeMethod: ctx.changeProductTypeHandler,
    },
    {
      prop: 'orderServiceType',
      name: '服务类型',
      type: 'select',
      options: ctx.serviceList,
    },
    {
      name: '指令下发时间从',
      prop: 'instructIssueStartDate',
      type: 'startDaterangePicker',
    },
    {
      name: '指令下发时间至',
      prop: 'instructIssueEndDate',
      type: 'endDaterangePicker',
    },
  ];
};

// 默认表头
export const defaultTableColumn = [
  {
    type: 'radio',
    visible: true,
    width: '50',
    fixed: 'left',
  },
  {
    field: 'contractCode',
    title: '合同编号',
    visible: true,
  },
  {
    field: 'businessDepartmentName',
    title: '部门',
    visible: true,
  },
  {
    field: 'platformCompanyName',
    title: '平台公司',
    visible: true,
  },
  {
    field: 'customerName',
    title: '客户名称',
    visible: true,
  },

  {
    field: 'orderCode',
    title: '订单编号',
    visible: true,
  },
  {
    field: 'productTypeName',
    title: '产品类型',
    visible: true,
  },
  {
    field: 'orderServiceTypeName',
    title: '服务类型',
    visible: true,
  },
  {
    field: 'instructCode',
    title: '指令单号',
    visible: true,
  },
  {
    field: 'instructIssueDate',
    title: '指令下发时间',
    visible: true,
  },
  {
    field: 'createdByName',
    title: '业务员',
    visible: true,
  },
  // {
  //   field: 'payableAccountPeriod',
  //   title: '编制人员',
  //   visible: true,
  // },
  {
    field: 'orderStatusName',
    title: '订单状态',
    visible: true,
  },
];
export const tableList = [
  {
    id: 1,
    orderCode: 1111,
    settlementDesc: '说明',
    companyName: 'A',
    departmentName: 'b',
    originalTotalAmount: 1,
    domesticTotalAmount: 1,
    currencyName: 'TEST',
    contractCode: 66666,
    projectInitiationNo: 88888,
    productName: '乐百氏',
  },
  {
    id: 2,
    orderCode: 2222,
    settlementDesc: 'eee',
    companyName: ' B',
    departmentName: 'c',
    originalTotalAmount: 2,
    domesticTotalAmount: 2,
    currencyName: 'TEST',
    contractCode: 88888,
    projectInitiationNo: 99999,
    productName: '可乐',
  },
  {
    id: 3,
    orderCode: 3333,
    settlementDesc: 'eee',
    companyName: ' B',
    departmentName: 'c',
    originalTotalAmount: 3,
    domesticTotalAmount: 3,
    currencyName: 'TEST',
    contractCode: 88888,
    projectInitiationNo: 99999,
    productName: '可乐',
  },
  {
    id: 4,
    orderCode: 4444,
    settlementDesc: 'eee',
    companyName: ' B',
    departmentName: 'c',
    originalTotalAmount: 4,
    domesticTotalAmount: 4,
    currencyName: 'TEST',
    contractCode: 88888,
    projectInitiationNo: 99999,
    productName: '可乐',
  },
  {
    id: 5,
    orderCode: 5555,
    settlementDesc: 'eee',
    companyName: ' B',
    departmentName: 'c',
    originalTotalAmount: 5,
    domesticTotalAmount: 5,
    currencyName: 'TEST',
    contractCode: 88888,
    projectInitiationNo: 99999,
    productName: '可乐',
  },
];
// 默认显示的按钮
export const defaultMenuBtnList = [
  // {
  //   id: 1,
  //   label: '新建',
  //   type: '0',
  //   attributes: {
  //     buttonStyle: 'el-icon-remove-outline',
  //     buttonUrl: 'add',
  //   },
  // },
  // {
  //   id: 2,
  //   label: '启用',
  //   type: '0',
  //   attributes: {
  //     buttonStyle: 'el-icon-remove-outline',
  //     buttonUrl: 'enable',
  //   },
  // },
  // {
  //   id: 3,
  //   label: '禁用',
  //   type: '0',
  //   attributes: {
  //     buttonStyle: 'el-icon-remove-outline',
  //     buttonUrl: 'forbid',
  //   },
  // },
  {
    id: 4,
    label: '导出',
    type: '0',
    attributes: {
      // buttonStyle: 'el-icon-remove-outline',
      buttonUrl: 'export',
    },
  },
  // {
  //   id: 5,
  //   label: '批量导入',
  //   type: '0',
  //   attributes: {
  //     buttonStyle: 'el-icon-remove-outline',
  //   },
  // },
  // {
  //   id: 6,
  //   label: '批准',
  //   type: '0',
  //   attributes: {
  //     buttonStyle: 'el-icon-remove-outline',
  //     buttonUrl: 'approval',
  //   },
  // },
  // {
  //   id: 7,
  //   label: '驳回',
  //   type: '0',
  //   attributes: {
  //     buttonStyle: 'el-icon-remove-outline',
  //   },
  // },
  {
    id: 8,
    label: '创建结算单',
    type: '0',
    attributes: {
      // buttonStyle: 'el-icon-remove-outline',
      buttonUrl: 'create',
    },
  },
];
import API from '@/api/intermodality/order';
export default {
  data() {
    return {
      productList: [],
      serviceAllList: [],
      serviceList: [],
    };
  },
  methods: {
    // 切换产品
    changeProductTypeHandler(val) {
      this.query.orderServiceType = '';
      this.serviceList = [];
      if (val == '0') {
        this.serviceList = this.serviceAllList.slice(0, 6);
      } else if (val == '1') {
        this.serviceList = this.serviceAllList.slice(6);
      }
    },
    // 产品列表
    getProductList() {
      this.$axios
        .post(API.DATA_DICT, {
          dictType: 'INTERMODALITY-PRODUCT-TYPE',
          tenantCode: this.userInfo.tenantCode,
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.productList = res.data.data || [];
            console.log(res.data.data, '产品');
          }
        });
    },
    // 服务列表
    getServiceList() {
      this.$axios
        .post(API.DATA_DICT, {
          dictType: 'INTERMODALITY-SERVICE-TYPE',
          tenantCode: this.userInfo.tenantCode,
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.serviceAllList = res.data.data || [];
            console.log(res.data.data, '服务');
          }
        });
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.getProductList();
      this.getServiceList();
    });
  },
};
